import * as React from 'react';

import * as styles from './styles.css';
import { BookedOverlay } from '../NewbuildingTiledCarousel/BookedOverlay';

export const NewbuildingBookedOverlay = () => {
  return (
    <div className={styles['container']}>
      <BookedOverlay />;
    </div>
  );
};
